<template>
  <div class="partner">
    <div class="shadow"></div>
    <div class="certificate-list">
      <div class="certificate-list-left">
        <div class="toobar">
          <div class="eng">RESOURCE</div>
          <div class="eng-font">教学资源</div>
        </div>
        <div
          :class="pindex == index ? 'column2' : 'column1'"
          v-for="(item,index) in dataList"
          :key="index"
        >
          <div @click="categoryChange(index)">{{item.name}}</div>
          <div v-if="pindex == index" style="float: right;margin-right: 20px;">></div>
        </div>
      </div>

      <div class="certificate-list-right">
        <!-- 教学资源 文章列表样式 -->
        <div v-if="sourceFlag">
          <div class="source-list">
            <router-link :to="pindex==0 ?'/downloads' : '/downloads1'" target="_blank">
              <img
                :src=" pindex==0 ? 'https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/03-1.png' : 'https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/03-2.png' "
              />
            </router-link>
            <a href="javascript:" @click="changeSourceFlag(1)">
              <img
                :src=" pindex==0 ? 'https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/04-2.png' : 'https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/04-1.png' "
              />
            </a>
            <a href="https://test.bernouly.com" target="_blank">
              <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/01.png" />
            </a>
            <a href="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/02_x2.png" target="_blank">
              <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/02.png" />
            </a>
          </div>
        </div>
        <div v-if="!sourceFlag">
          <div class="source-list1">
            <div v-if="pindex == 0" class="down-list">
              <div class="down-item">
                <div class="down-item-left">
                  <a
                    href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/垃圾焚烧发电运行与维护职业技能等级证书配套课件（初级）.pdf"
                  >垃圾焚烧发电运行与维护职业技能等级证书配套课件（初级）</a>
                  <img src="../../assets/1+X/pdf.png" />
                </div>
              </div>
              <div class="down-item">
                <div class="down-item-left">
                  <a
                    href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/垃圾焚烧发电运行与维护职业技能等级证书配套课件（中级）.pdf"
                  >垃圾焚烧发电运行与维护职业技能等级证书配套课件（中级）</a>
                  <img src="../../assets/1+X/pdf.png" />
                </div>
              </div>
              <div class="down-item">
                <div class="down-item-left">
                  <a
                    href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/垃圾焚烧发电运行与维护职业技能等级证书配套课件（高级）.pdf"
                  >垃圾焚烧发电运行与维护职业技能等级证书配套课件（高级）</a>
                  <img src="../../assets/1+X/pdf.png" />
                </div>
              </div>
            </div>
            <!-- <div v-if="pindex == 1" class="down-list">
							<div class="down-item">
								<div class="down-item-left"><a href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/垃圾焚烧发电运行与维护职业技能等级证书配套课件（初级）.pdf">垃圾焚烧发电运行与维护职业技能等级证书配套课件（初级）</a><img src="../assets/1+X/pdf.png" /></div>
							</div>
							<div class="down-item">
								<div class="down-item-left"><a href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/垃圾焚烧发电运行与维护职业技能等级证书配套课件（初级）.pdf">垃圾焚烧发电运行与维护职业技能等级证书配套课件（初级）</a><img src="../assets/1+X/pdf.png" /></div>
							</div>
							<div class="down-item">
								<div class="down-item-left"><a href="https://bernouly.oss-cn-beijing.aliyuncs.com/download/垃圾焚烧发电运行与维护职业技能等级证书配套课件（高级）.pdf">垃圾焚烧发电运行与维护职业技能等级证书配套课件（高级）</a><img src="../assets/1+X/pdf.png" /></div>
							</div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Article,
  ArChildren,
  timestampToTime,
  Serchdata,
} from "../../services/article";
import { setTimeout } from "timers";
import { log } from "util";
export default {
  components: {},
  data() {
    return {
      page: {
        totalCount: 0, //总记录数
        pageCount: 1, //总页数
        currentPage: 0, //当前页
        perPage: 8, //每页显示数量
      },
      pindex: 0, //一级分类子菜单id-选项卡样式控制参数
      /**
       * 一级分类子菜单
       * cate_id:分类子菜单id
       * name:分类子菜单名称
       * 测试数据 部署时清空
       */
      dataList: [],
      sourceFlag: true, //控制教材资源显示
      activeName: 0, //一级分类id
      tabChangeNum: 0,
      menuList: [
        {
          id: "137",
          name: "政策标准",
          path: "/certificatechildren",
        },
        {
          id: "138",
          name: "通知公告",
          path: "/notice",
        },
        {
          id: "139",
          name: "师资培训",
          path: "/train",
        },
        {
          id: "140",
          name: "教学资源",
          path: "/resource",
        },
        {
          id: "141",
          name: "证书信息",
          path: "/certificateInfo",
        },
        {
          id: "142",
          name: "学分银行",
          path: "/creditbank",
        },
        {
          id: "143",
          name: "信息查询",
          path: "/inqure",
        },
      ],
    };
  },
  mounted() {
    this.menuClick(3);
  },
  methods: {
    //一级分类标题点击事件 : 根据pid查询cid
    menuClick(index) {
      this.searchFlag = true;
      this.searchImgUrl = "";
      this.sourceFlag = true;
      this.pageIndex = 1; //初始化页码
      this.activeName = index; //改变选项卡样式
      this.pindex = 0; //改变二级菜单样式
      //console.log(index, this.menuList, "一级分类标题点击事件");

      //师资培训 直接查询文章
      // if(index==2){
      // 	this.videoIndex=0;//video-mini-list开始下标
      // 	this.playIndex=0;//video-main所显示播放列表中的视频内容
      // 	this.videoFlag=true;
      // 	let cid = this.menuList[index].id;
      // 	this.article(cid,1);
      // }else{
      let dataList = [];
      this.dataList = [];
      let pid = this.menuList[index].id;
      //console.log(this.menuList, "res1");
      //获取二级分类
      ArChildren({
        pid: pid,
      }).then((res1) => {
        //console.log(res1, "res1");
        if (res1.items.length > 0) {
          this.dataList = [];
          res1.items.forEach((item) => {
            dataList.push(item);
          });
          //这里接口跨域，this.dataList获取不到值
          this.dataList = dataList;
          //console.log(dataList, "dataList");
          let cid = this.dataList[0].id;
          //获取二级分类下的文章列表
          if (index != 2) {
            this.article(cid, 1);
          }
        }
      });
      // }
    },
    changeSourceFlag(index) {
      if (index == 0) {
        this.sourceFlag = true;
      } else {
        this.sourceFlag = false;
      }
    },
    //根据cid查询文章列表
    categoryChange(index) {
      //根据tab页面切换，展示不同页面
      this.tabChangeNum = index;
      //初始化searchStyle值
      this.searchStyle1 = 1;
      this.searchStyle2 = 0;
      this.searchImgUrl = "";
      this.searchFlag = true;

      //console.log(index, `tab切换，现在切换到${index}`);

      this.sourceFlag = true; // 恢复教学资源显示的初始布局
      this.pindex = index; //修改二级分类菜单样式控制参数
      this.pageIndex = 1; //初始化页码
      let cid = this.dataList[index].id;
      this.article(cid, 1);
    },
    article(cid, page) {
      this.titleList = [];
      let titleList = [];
      Article({
        category_id: cid,
        page_size: 8,
        page: page,
      }).then((res2) => {
        if (res2.items.length > 0) {
          res2.items.forEach((citem) => {
            //时间格式处理   原有逻辑↓
            //let tm = timestampToTime(citem.release_time);
            //适配java后端需要做时间转换
            let tm = timestampToTime(new Date(citem.release_time).getTime()/1000);
            citem.tm = tm;
            titleList.push(citem);
          });
          this.titleList = titleList;
          //处理分页
          this.page.totalCount = res2._meta.totalCount;
          this.page.pageCount = res2._meta.pageCount;
          this.page.currentPage = res2._meta.currentPage;
        }
      });
    },
  },
};
</script>

<style scoped>
.partner {
  background-color: white;
}
.shadow {
  height: 100px;
  width: 100%;
  background-color: #d7d7d7;
}
.certificate-list {
  width: 1200px;
  min-height: 450px;
  margin: 0 auto;
}
.certificate-list-left {
  float: left;
  width: 185px;
  /* min-height: 450px; */
}
.toobar {
  height: 78px;
  padding-top: 30px;
  border-bottom: 1px solid #6d5c55;
}

.eng {
  font-size: 16px;
  color: #666666;
}

.eng-font {
  font-size: 26px;
}

.column1 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}

.column2 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  color: #0055d3;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}

.column1:hover,
.column2:hover {
  color: #0055d3;
  cursor: pointer;
}

.certificate-list-right {
  position: relative;
  display: inline-block !important;
  width: 1014px;
  height: auto;
  border-left: 1px solid #d4d4d4;
}
.source-list1 {
  min-height: 520px;
  margin-top: 50px;
  margin-left: 70px;
  margin-bottom: 100px;
}

.source-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 520px;
  margin-top: 50px;
  margin-left: 70px;
  margin-bottom: 80px;
}

.source-list img:hover {
  transition: all 0.5s;
  transform: scale(1.02);
}

.source-list-item {
  display: flex;
  justify-content: space-between;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #666666;
  border-bottom: 1px #eeeeee solid;
}

.source-list-item-title img {
  margin-top: -2px;
  vertical-align: middle;
  display: inline-block;
  margin-left: 8px;
}
.source-list-item-title a {
  color: #333;
}

.source-list-item-title a:hover {
  color: #0a57f4;
}
a:hover {
  cursor: pointer;
}

.down-item {
  height: 80px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px #cccccc solid;
  line-height: 80px;
}
.down-item-left {
  color: #333333;
  margin-left: 20px;
}

.down-item-left img {
  margin-top: -4px;
  vertical-align: middle;
  display: inline-block;
  margin-right: 20px;
}

.down-item-right {
  margin: auto 0;
  margin-right: 20px;
}

.down-item-right p {
  width: 136px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 2px solid #0055d3;
  border-radius: 30px;
  background: #fff;
  cursor: pointer;
}

.down-item-right p:hover {
  background: #0055d3;
  color: #fff;
}
</style>
